module.exports = __webpack_public_path__ + "static/img/refresh-icon.100f6d5d.svg";